export let BillingDayOfMonthType;

(function (BillingDayOfMonthType) {
  BillingDayOfMonthType["LastDayOfMonth"] = "lastDayOfMonth";
  BillingDayOfMonthType["DayOfMonth"] = "dayOfMonth";
})(BillingDayOfMonthType || (BillingDayOfMonthType = {}));